// ============================================================
// Centralized Configuration
// ============================================================

const config = Object.freeze({
  api: {
    baseURL: import.meta.env.VITE_API_URL || 'https://api.shreejischools.com/shreeji-sms/api/v1',
    timeout: 15000,
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'Multi-School ERP System',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },
  query: {
    staleTime: 5 * 60 * 1000,     // 5 minutes
    cacheTime: 10 * 60 * 1000,    // 10 minutes
    retryCount: 1,
    refetchOnWindowFocus: false,
  },
  storage: {
    tokenKey: 'erp_auth_token',
    schoolKey: 'erp_current_school',
    themeKey: 'erp_theme_mode',
  },
});

export default config;
